import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@/store/index";
import { checkIsAdmin } from "@/utils/users";

export const selectUser = (state: RootState) => state.user;

export const selectUserLoading = createSelector(
  selectUser,
  (user) => user.loading,
);

export const selectUserVideoEnabled = createSelector(
  selectUser,
  (user) => user.isVideoEnabled,
);

export const selectUserAudioEnabled = createSelector(
  selectUser,
  (user) => user.isAudioEnabled,
);

export const selectUserData = createSelector(
  selectUser,
  (user) => user.user,
);

export const selectUserAvatar = createSelector(
  selectUserData,
  (user) => user?.avatar || null,
);

export const selectUserIsLoggedIn = createSelector(
  selectUserData,
  (user) => !!user,
);

export const selectUserIsAdmin = createSelector(
  selectUserData,
  (user) => checkIsAdmin(user?.id),
);
